import React, { FC } from 'react';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { VIEWER_HOOKS } from '@wix/pricing-plans-common/hooks';
import { useSettings } from '@wix/tpa-settings/react';
import { useEnvironment, useExperiments, WidgetProps } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import { useSettingsParams } from '../../../hooks';
import { noModal, ModalType, GenericModal } from '../../../types/common';
import { MainViewDisplayType } from '../../PackagePicker/settingsParams';
import { AlertModal } from '../../PackagePicker/Widget/AlertModal';
import List, { ListWidgetProps } from '../../PackagePicker/Widget/List';
import { EmptyStateProps } from '../../PackagePicker/Widget/List/EmptyState';
import { PlanListWidgetContext } from './PlanListWidgetContext';

const LazyTabsView = loadable(() => import('../../PackagePicker/Widget/TabsView'));

export interface ListWidgetWithModalProps extends ListWidgetProps {
  modal: GenericModal<ModalType.PurchaseInPreview> | typeof noModal;
}

const Widget: FC<WidgetProps<ListWidgetWithModalProps>> = (props) => {
  const { isMobile } = useEnvironment();
  const emptyState: EmptyStateProps = { isInWidget: true };
  const width = props.host.dimensions.width ?? (isMobile ? 320 : 980);

  return (
    <PlanListWidgetContext locale={props.locale} width={width}>
      <View {...props} emptyState={emptyState} />
      {props.modal.type === ModalType.PurchaseInPreview && <AlertModal {...props.modal} />}
    </PlanListWidgetContext>
  );
};

const View: FC<WidgetProps<ListWidgetWithModalProps> & { emptyState: EmptyStateProps }> = (props) => {
  const { experiments } = useExperiments();
  const settings = useSettings();
  const settingsParams = useSettingsParams();

  const isVariantsEnabled = experiments.enabled(TPA_EXPERIMENTS.ENABLE_VARIANTS);
  const displayType = settings.get(settingsParams.mainViewDisplayType);

  if (isVariantsEnabled && displayType === MainViewDisplayType.TABS) {
    return <LazyTabsView {...props} dataHook={VIEWER_HOOKS.PLAN_LIST_WRAPPER} />;
  }

  return <List {...props} dataHook={VIEWER_HOOKS.PLAN_LIST_WRAPPER} />;
};

export default Widget;
